import script from "./info.vue?vue&type=script&lang=ts&setup=true"
export * from "./info.vue?vue&type=script&lang=ts&setup=true"

import "./info.vue?vue&type=style&index=0&id=a315f9fa&lang=css"
import "./info.vue?vue&type=style&index=1&id=a315f9fa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a315f9fa"]])

export default __exports__